import { fetchAllBackendChallenges } from 'features/Backend'
import { GetServerSideProps } from 'next'

import { createQueryClient, dehydrateState } from 'config/query'

export { BackendChallenges as default } from 'features/Solve'

export const getServerSideProps: GetServerSideProps = async () => {
  const queryClient = createQueryClient()

  await queryClient.prefetchQuery(['backend_challenges'], () =>
    fetchAllBackendChallenges()
  )
  return { props: { ...dehydrateState(queryClient) } }
}
